import { SET_MODAL } from './types';
export var setModal = function setModal(newModal) {
  return {
    type: SET_MODAL,
    payload: newModal
  };
};